import { genToolTip, formateXaxis } from './utils';
import { colors } from '@/shared/utils';
function genOptions(data) {
    const legendData = [];
    const seriesData = [];
    const isRate = data.isRate;
    data.catagory && data.catagory.forEach((item, index) => {
        legendData.push({
            name: item.name,
            icon: 'circle',
        });
        const seriesArr = [];
        if (data.catagory[index].yAxis && data.catagory[index].yAxis.length) {
            data.catagory[index].yAxis.forEach((item, i) => {
                seriesArr.push({
                    value: (+item * (isRate ? 100 : 1) || 0).toFixed(2),
                    isRate,
                });
            });
        }
        seriesData.push({
            name: item.name,
            data: seriesArr,
            type: 'line',
            showSymbol: seriesArr.length <= 1,
            lineStyle: {
                color: colors[index],
            },
            itemStyle: {
                color: colors[index],
            },
        });
    });
    return {
        legendData,
        seriesData,
    };
}
export default function keyEffect30Days(data) {
    const { legendData, seriesData } = genOptions(data);
    const timeObj = formateXaxis(data.xAxis);
    return {
        grid: { bottom: 50, top: 16, left: 20, right: 20 },
        legend: {
            bottom: -4,
            itemWidth: 6,
            itemHeight: 6,
            itemGap: 32,
            padding: [5, 8, 5, 5],
            data: legendData,
            textStyle: {
                color: '#5e5e66',
            },
        },
        tooltip: {
            trigger: 'axis',
            backgroundColor: '#fff',
            formatter(params) {
                return genToolTip(params, { map: timeObj.map });
            },
            padding: 12,
            axisPointer: {
                lineStyle: {
                    type: 'dashed',
                    color: '#ccc',
                },
            },
            textStyle: {
                color: '#000',
            },
            extraCssText: 'box-shadow: 0 2px 8px rgba(0,0,0,0.15);',
        },
        xAxis: {
            type: 'category',
            boundaryGap: [32, 32],
            axisTick: {
                show: false,
            },
            data: timeObj.time,
            axisLine: {
                lineStyle: {
                    color: '#ccc',
                },
            },
        },
        yAxis: [
            {
                type: 'value',
                splitLine: {
                    lineStyle: {
                        type: 'dashed',
                        color: '#ededf0',
                    },
                },
                position: 'left',
                axisTick: {
                    show: false,
                },
                axisLine: {
                    show: false,
                },
                axisLabel: {
                    show: false,
                },
            },
            {
                type: 'value',
                splitLine: {
                    lineStyle: {
                        type: 'dashed',
                        color: '#ededf0',
                    },
                },
                position: 'right',
                axisTick: {
                    show: false,
                },
                axisLine: {
                    show: false,
                },
                axisLabel: {
                    show: false,
                },
            },
        ],
        series: seriesData,
    };
}
